import(/* webpackMode: "eager" */ "/root/meet/frontend/app/page.tsx");
